import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Segment, Dimmer, Loader, Modal } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';

// Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';
import {
    requestCreateEvent,
    requestUpdateEvent
    // @ts-ignore
} from 'services/events/actions';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

// Workspaces
import {
    makeSelectQueryStringNumberValue,
    makeSelectQueryStringBooleanValue
    // @ts-ignore
} from 'workspaces/react-router-selectors';

// Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import ErrorGate from 'components/ErrorGate';
import LoadingGate from 'components/LoadingGate';
// @ts-ignore
import EventRequest from '../EventRequest';
// @ts-ignore
import GeneralEventForm from '../GeneralEventForm';

interface ConnectedProps {
    selectedSchema?: number;
    selectedEvent?: number;
    open?: boolean;
}

interface DispatchProps {
    updateQueryString: Function;
    requestCreateEvent: Function;
    requestUpdateEvent: Function;
}

type Props = ConnectedProps & DispatchProps;

export class GeneralEventModal extends React.PureComponent<Props> {
    handleClose = (): void => {
        this.props.updateQueryString({
            generalEventModal: undefined,
            selectedSchema: undefined,
            selectedEvent: undefined,
            selectedCurrentEntityId: undefined,
            newGroup: undefined
        });
    };

    handleSubmit = (values: Record<string, any>): void => {
        const { selectedEvent, selectedSchema } = this.props;
        if (selectedEvent) {
            this.props.requestUpdateEvent(selectedEvent, {
                ...values,
                entityId: undefined,
                schemaId: undefined,
                jobs: values.jobs.map((value: any) => ({
                    jobType: value.jobType,
                    assignedUsers: value.assignedUsers
                }))
            });
        }
        if (selectedSchema) {
            this.props.requestCreateEvent({
                ...values,
                schemaId: selectedSchema,
                groupId: values.groupId || undefined
            });
        }
    };

    render(): React.ReactElement {
        const { open, selectedSchema, selectedEvent } = this.props;
        return (
            <Modal
                size="fullscreen"
                open={open}
                centered={false}
                onClose={this.handleClose}
                closeIcon
            >
                <ErrorBoundary
                    namespace="GeneralEventModal"
                    FallbackComponent={<ErrorBoundaryAlert />}
                >
                    {selectedEvent && (
                        <React.Fragment>
                            <EventRequest eventId={selectedEvent} />
                            <ErrorGate namespace="EVENT_LOAD">
                                <LoadingGate
                                    namespace="EVENT_LOAD"
                                    LoadingComponent={
                                        <Segment basic padded="very">
                                            <Dimmer active inverted>
                                                <Loader inverted />
                                            </Dimmer>
                                        </Segment>
                                    }
                                >
                                    <GeneralEventForm
                                        eventId={selectedEvent}
                                        disableIntructions
                                        onClose={this.handleClose}
                                        onSubmit={this.handleSubmit}
                                    />
                                </LoadingGate>
                            </ErrorGate>
                        </React.Fragment>
                    )}
                    {!selectedEvent && (
                        <GeneralEventForm
                            schemaId={selectedSchema}
                            onClose={this.handleClose}
                            onSubmit={this.handleSubmit}
                        />
                    )}
                </ErrorBoundary>
            </Modal>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    selectedSchema: makeSelectQueryStringNumberValue('selectedSchema'),
    selectedEvent: makeSelectQueryStringNumberValue('selectedEvent'),
    open: makeSelectQueryStringBooleanValue('generalEventModal')
});

export default connect(mapStateToProps, {
    updateQueryString,
    requestCreateEvent,
    requestUpdateEvent
})(GeneralEventModal);
